import { getAllParentPath } from '@/router/helper/menuHelper';
import { getPermissionStore } from '@/store';

// ===========================
// ==========Helper===========
// ===========================

export const getMenus = () => getPermissionStore().getVisibleBackMenuList;

export function getCurrentParentPath(currentPath: string) {
  const allParentPath = getAllParentPath(getMenus(), currentPath);
  return allParentPath?.[0] || '';
}

export function getShallowMenus() {
  return getMenus().map((item) => Object.assign({}, item, { children: undefined }));
}

export function getChildrenMenus(parentPath: string) {
  const parent = getMenus().find((item) => item.path === parentPath);

  if (!parent || !parent.children || parent.meta?.hideChildrenInMenu) {
    return [];
  }
  return parent.children;
}
